<template>
    <hts-drawer
        v-model="visible"
        :submit="handleSubmitFormAddNode"
        :rules="cRules"
        size="large"
        :title="$t('labels.nodeModule.addNode')"
        @close="closeOverSide">
        <div
            class="relative h-full w-full"
            :style="{ minWidth: minWidthScroll }">
            <div
                class="w-full h-full overflow-x-auto"
                style="max-height: calc(100% - 20px)">
                <div class="flex gap-2">
                    <div
                        class="w-1/2"
                        :class="sizeItemInput">
                        <hts-card :title="$t('labels.location')">
                            <hts-admincp-select-location
                                ref="selectLocation"
                                v-model="dataFormAddNode.location"
                                :text="dataFormAddNode.locationName"
                                required
                                name="location"
                                prop="location"
                                key-id="_id"
                                key-label="locationName"
                                :label="$t('labels.locationName')"
                                filterable
                                clearable
                                creatable
                                @change="handleChangeLocation"
                                @create-new="openAddLocation" />
                            <hts-form-input
                                v-model="dataFormAddNode.address"
                                :label="$t('labels.nodeModule.address')"
                                :color="props.color"
                                disabled
                                required
                                name="address"
                                prop="address" />
                        </hts-card>

                        <hts-card :title="$t('labels.nodeType')">
                            <div class="grid-cols-2 grid gap-4">
                                <hts-admincp-select-node-type
                                    v-model="dataFormAddNode.nodeType"
                                    v-model:text="dataFormAddNode.nodeTypeName"
                                    required
                                    key-id="_id"
                                    key-label="name"
                                    :filterable="true"
                                    class="w-full"
                                    :clearable="true" />

                                <add-toll-stations
                                    ref="addTollStations"
                                    @update="(val) => changeTollStationsPrices(val)" />

                                <hts-form-button
                                    v-if="dataFormAddNode.nodeTypeName === 'Trạm thu phí' && !checkEnterTollStationsPrices"
                                    class="mt-9 text-center"
                                    color="warning"
                                    icon-name="hi-plus-circle-icon"
                                    icon-position="right"
                                    type="button"
                                    :outline="true"
                                    @click="openTollStationTariff">
                                    {{ $t('labels.tollStationTariff') }}
                                </hts-form-button>

                                <hts-form-button
                                    v-if="dataFormAddNode.nodeTypeName === 'Trạm thu phí' && checkEnterTollStationsPrices"
                                    class="mt-9 text-center"
                                    color="success"
                                    icon-name="hi-eye-icon"
                                    icon-position="right"
                                    type="button"
                                    :outline="true"
                                    @click="openTollStationTariff">
                                    {{ $t('labels.watchTollStationTariff') }}
                                </hts-form-button>

                                <div v-if="dataFormAddNode.nodeTypeName === 'Kho'">
                                    <hts-form-radio
                                        v-model="dataFormAddNode.warehouseType"
                                        :label="$t('labels.nodeModule.warehouseType')"
                                        required
                                        value-key="value"
                                        name="warehouseType"
                                        prop="warehouseType"
                                        :items="listWarehouseType" />
                                </div>
                            </div>

                            <span class="mt-3">
                                {{ $t('labels.businessTask') }}
                                <span class="text-error-500 ml-1">
                                    *
                                </span>
                            </span>

                            <div
                                v-for="(business, index) in businessData"
                                :key="business">
                                <hts-form-disclosure
                                    color="main"
                                    size="large"
                                    :is-have-children="true">
                                    <template #reference>
                                        <div class="flex align-middle items-center gap-3 min-h-10 rounded-lg text-white bg-main-500 hover:bg-main-600 w-full">
                                            <input
                                                type="checkbox"
                                                class="w-[17.5px] h-[17.5px]"
                                                :checked="Object.keys(dataFormAddNode.businesses).includes(business._id)"
                                                :value="business._id"
                                                @click="(e) => businessClick(e, business._id, business)" >
                                            <span>
                                                {{ business.name }}
                                            </span>
                                        </div>
                                    </template>
                                    <template #children>
                                        <div
                                            v-for="(task, subIndex) in business.tasks"
                                            :key="task">
                                            <div class="flex align-middle items-center gap-3 min-h-10 rounded-lg text-white mt-3 ml-10 p-2 pl-3 bg-main-400 hover:bg-main-600">
                                                <input
                                                    class="w-[17.5px] h-[17.5px]"
                                                    type="checkbox"
                                                    :checked="
                                                        Object.keys(dataFormAddNode.businesses).includes(business._id) && dataFormAddNode.businesses[business._id]?.includes(task._id)
                                                    "
                                                    :value="task._id"
                                                    @click="taskClick(business._id, task._id)" >
                                                <span>
                                                    {{ task.name }}
                                                </span>
                                            </div>
                                        </div>
                                    </template>
                                </hts-form-disclosure>
                            </div>
                        </hts-card>

                        <hts-card :title="$t('labels.generalInformation')">
                            <!--
                              <hts-admincp-select-company
                              v-model="dataFormAddNode.company"
                              :label="$t('labels.ownerCompany')"
                              :color="props.color"
                              name="ownerCompany"
                              prop="ownerCompany"
                              type="OWNER"
                              :filterable="true"
                              :clearable="true" />
                            -->

                            <working-time v-model="dataFormAddNode.workingTime" />

                            <hts-form-checkbox
                                v-model="dataFormAddNode.holidayWorking"
                                :items="[{ label: $t('labels.holidayWorking'), value: true }]" />

                            <hts-form-checkbox
                                v-if="dataFormAddNode.holidayWorking"
                                v-model="dataFormAddNode.holidayWorkingOverTime"
                                class="ml-5"
                                :items="[{ label: $t('labels.nodeModule.overTime'), value: true }]" />

                            <hts-form-checkbox
                                v-model="dataFormAddNode.hasLoadLimit"
                                :items="[{ label: $t('labels.nodeModule.hasLoadLimit'), value: true }]"
                                @change="dataFormAddNode.loadLimit = null" />

                            <hts-form-input
                                v-if="dataFormAddNode.hasLoadLimit"
                                v-model="dataFormAddNode.loadLimit"
                                :label="$t('labels.loadLimit')"
                                :color="props.color"
                                type="number"
                                name="loadLimit"
                                prop="loadLimit"
                                required />

                            <!--  Loại xe, cont -->
                            <hts-form-checkbox
                                v-model="dataFormAddNode.liftingVehicleReceivingForce"
                                class="w-full"
                                type="list"
                                :label="$t('labels.liftingVehicleReceivingForce')"
                                :items="[
                                    { label: $t('labels.containerTruck'), value: 'container-truck' },
                                    { label: $t('labels.truck'), value: 'truck' }
                                ]" />
                            <div class="grid gap-4 grid-cols-2">
                                <div>
                                    <hts-form-select
                                        v-show="dataFormAddNode.liftingVehicleReceivingForce.includes('container-truck')"
                                        v-model="dataFormAddNode.contCategory"
                                        :label="$t('labels.containerType')"
                                        :filterable="true"
                                        :clearable="true"
                                        multiple
                                        required
                                        :items="dataSelectWorkFlowData"
                                        key-id="value"
                                        key-label="label"
                                        prop="containerType"
                                        name="containerType"
                                        :color="props.color" />
                                </div>

                                <div>
                                    <hts-form-input
                                        v-show="dataFormAddNode.liftingVehicleReceivingForce.includes('truck')"
                                        v-model="dataFormAddNode.maximumLoad"
                                        :label="$t('labels.maximumLoad')"
                                        :color="props.color"
                                        type="number"
                                        name="maximumLoad"
                                        prop="maximumLoad"
                                        class="w-full">
                                        <template #custom>
                                            <hts-tooltip class="mt-2 ml-2">
                                                <div>
                                                    <span class="font-bold">
                                                        {{ $t('labels.maximumVehicleLoadWarning') }}
                                                    </span>
                                                </div>
                                                <template #reference>
                                                    <hi-information-circle-icon class="flex items-center text-green-500 w-6 h-6" />
                                                </template>
                                            </hts-tooltip>
                                        </template>
                                    </hts-form-input>
                                </div>
                            </div>
                        </hts-card>

                        <hts-card :title="$t('labels.liftingCommodityReceivingForce')">
                            <hts-form-checkbox
                                v-model="dataFormAddNode.typeReefer"
                                :label="$t('labels.isReefer')"
                                required
                                value-key="value"
                                :items="listRadioReeferTypes" />
                            <hts-form-checkbox
                                v-model="dataFormAddNode.typeDangerous"
                                :label="$t('labels.isDangerous')"
                                required
                                value-key="value"
                                :items="listRadioDangerousTypes" />
                            <hts-form-checkbox
                                v-model="dataFormAddNode.typeFragileGoods"
                                :label="$t('labels.isFragile')"
                                required
                                value-key="value"
                                :items="listRadioFragileTypes" />
                            <!--
                              <hts-form-checkbox
                              v-model="dataFormAddNode.goodType"
                              :label="$t('labels.goodsTypes')"
                              required
                              value-key="value"
                              :items="listRadioGoodTypes" />
                            -->
                            <!--
                              <hts-form-checkbox
                              v-model="dataFormAddNode.typeCommodity"
                              :label="$t('labels.overweightCargo2')"
                              required
                              value-key="value"
                              name="overweightCargo2"
                              prop="overweightCargo2"
                              :items="listRadioTypeCommodity" />
                            -->
                        </hts-card>

                        <hts-form-input
                            v-model="dataFormAddNode.description"
                            :label="$t('labels.description')"
                            :color="props.color"
                            name="description"
                            prop="description"
                            class="mb-8" />

                        <div class="h-8 min-h-8" />
                    </div>
                    <div class="w-1/2 h-full" />
                </div>
            </div>

            <div
                class="w-1/2 absolute right-0 top-0 h-full pl-2 pr-5"
                style="max-height: calc(100% - 100px)">
                <hts-map-autocomplete
                    :label="$t('labels.findPosition')"
                    :placeholder="$t('labels.nodeModule.search')"
                    @get-place-detail="handleChoosePosition" />
                <hts-map-node
                    class="mt-5"
                    :node-list="locationList"
                    :center-position="nodePosition"
                    center-marker
                    @clickMarker="handleSelectMyLocation" />
            </div>
        </div>

        <add-location
            ref="addLocation"
            @refresh-tables="getAllNodeLocation"
            @newLocation="newLocation" />
    </hts-drawer>
</template>

<script setup lang="ts">
import cloneDeep from 'lodash-es/cloneDeep'
import AddLocation from '../location/ignore/add.vue'
import dataForm from './imports/model'
import WorkingTime from './node/working-time.vue'
import AddTollStations from './node/toll-stations.vue'
import { $store, $urlSystem } from '#imports'

import screen from '~/components/utils/screen'
const breakpoint = screen()
const minWidthScroll = computed(() => {
  return `${breakpoint.value.thresholds.sm}px`
})

const store = $store()

const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: Number,
    default: 0
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  },
  nodeTypes: {
    type: Array,
    default: () => {}
  }
})
const dataFormAddNode = reactive({ ...dataForm.initValue })
const nodePosition = reactive({
  lat: 10.7561542,
  lng: 106.6896784,
  placeId: '' || null || undefined
})

const emits = defineEmits(['close', 'refreshTables'])
const visible = ref(false)
const locationList = ref<Array<{ [key: string]: any }>>([])
const businessData = ref<{ [key: string]: string }>()
const addTollStations = ref()
const addLocation = ref()
const selectLocation = ref()

const cRules = computed(() => {
  const rules: any = {
    location: 'required',
    nodeType: 'required'
  }

  if (dataFormAddNode.hasLoadLimit) {
    rules.loadLimit = 'required'
  }

  return rules
})

const openAddNode = async () => {
  visible.value = true
  await getAllNodeLocation()
  getTollStationStructure()
}

const openAddLocation = () => {
  if (addLocation?.value) {
    if (selectLocation.value) {
      selectLocation.value.hide()
    }
    addLocation?.value.open()
  }
}

defineExpose({
  openAddNode
})

const closeOverSide = () => {
  undo()
  visible.value = false
}
const undo = () => {
  Object.assign(dataFormAddNode, {
    ...dataForm.initValue
  })
  dataFormAddNode.businesses = []
  dataFormAddNode.workingTime = {
    mon: [],
    tue: [],
    wed: [],
    thu: [],
    fri: [],
    sat: [],
    sun: []
  }
  dataFormAddNode.tollStationsPrices = {
    vehicle: [],
    cont: []
  }
  dataFormAddNode.hasLoadLimit = false
  dataFormAddNode.liftingVehicleReceivingForce = []
  dataFormAddNode.contCategory = [20, 40, 45]
  dataFormAddNode.maximumLoad = undefined
  dataFormAddNode.typeCommodity = ['NORMAL']
  dataFormAddNode.goodType = ['SOLID']
  dataFormAddNode.typeReefer = ['NOTREEFER']
  dataFormAddNode.typeDangerous = ['NOTDANGEROUS']
  dataFormAddNode.typeFragileGoods = ['NOTFRAGILE']
  businessData.value = {} as any
}

const changeTollStationsPrices = (val: any) => {
  dataFormAddNode.tollStationsPrices = val
}

const newLocation = (data: any) => {
  if (data?._id && data?.locationName && data?.address) {
    dataFormAddNode.location = data?._id
    dataFormAddNode.locationName = data?.locationName
    dataFormAddNode.address = data?.address
  }

  if (data?.lat && data.lng) {
    nodePosition.lat = Number(data?.lat)
    nodePosition.lng = Number(data?.lng)
    nodePosition.placeId = data.placeId
  }
}

// reset trọng tải tối đa khi bỏ chọn loại xe
const oldLiftingVehicleReceivingForce = ref([] as string[])
watch(
  () => dataFormAddNode.liftingVehicleReceivingForce,
  (val: string[]) => {
    if (oldLiftingVehicleReceivingForce.value.includes('truck') && !val.includes('truck')) {
      dataFormAddNode.maximumLoad = null
    }
    oldLiftingVehicleReceivingForce.value = cloneDeep(val)
  },
  { deep: true }
)

const handleSubmitFormAddNode = () => {
  if (!checkEnterWorkingTime('inTime')) {
    process.client && $toast().error('Vui lòng nhập thời gian làm việc trong giờ')
    return
  }

  if (!checkEnterWorkingTime('overTime') && dataFormAddNode.holidayWorkingOverTime) {
    process.client && $toast().error('Vui lòng cài đặt thời gian làm việc ngoài giờ')
    return
  }

  if (!checkBusinessAndTask()) {
    return
  }

  if (dataFormAddNode.nodeTypeName === 'Trạm thu phí' && !checkTollStationsPrices()) {
    return
  }

  const api = $urlSystem.node.addNode
  $api(api, { body: dataFormAddNode })
    .then((data) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (responseData?.success) {
        undo()
        emits('refreshTables')
        process.client && $toast().success($t('labels.nodeModule.addSuccess'))
        emits('close')
        visible.value = false
      }
    })
    .catch((error: any) => error)
}

const checkEnterWorkingTime = (type: string) => {
  try {
    for (const day in dataFormAddNode.workingTime) {
      const dayTimeSlots = dataFormAddNode.workingTime[day]
      for (const timeSlot of dayTimeSlots) {
        if (timeSlot.type === type) {
          return true
        }
      }
    }
    return false
  } catch (e) {
    return false
  }
}

const checkBusinessAndTask = () => {
  try {
    if (dataFormAddNode.businesses && Object.keys(dataFormAddNode.businesses).length === 0) {
      process.client && $toast().error($t('labels.pleaseSelectBusiness'))
      throw new Error('No business selected')
    }

    Object.keys(dataFormAddNode.businesses).forEach((business: string) => {
      if (dataFormAddNode.businesses[business].length === 0) {
        process.client && $toast().error($t('labels.pleaseSelectTask'))
        throw new Error('No task selected')
      }
    })
    return true
  } catch (e) {
    return false
  }
}

const checkTollStationsPrices = () => {
  if (!store.data.tollStationStructure) {
    process.client && $toast().error($t('labels.pleaseInstallTollStationTariffStructure'))
    return false
  }

  const vehiclePricesData = dataFormAddNode.tollStationsPrices.vehicle
  if (Object.keys(vehiclePricesData).length === 0) {
    process.client && $toast().error($t('labels.pleaseEnterTripTickets'))
    return false
  }

  for (const item in vehiclePricesData) {
    if (typeof vehiclePricesData[item].trip !== 'number') {
      process.client && $toast().error($t('labels.pleaseEnterTripTickets'))
      return false
    }
  }

  const contPricesData = dataFormAddNode.tollStationsPrices.cont

  for (const item in contPricesData) {
    if (typeof contPricesData[item].trip !== 'number') {
      process.client && $toast().error($t('labels.pleaseEnterTripTickets'))
      return false
    }
  }
  return true
}

// select option location
const handleChangeLocation = (val: { [key: string]: any }) => {
  // change của select option trả về array những item đã chọn
  dataFormAddNode.address = val[0]?.address || ''
  nodePosition.lat = Number(val[0]?.lat) || 10.7561542
  nodePosition.lng = Number(val[0]?.lng) || 106.6896784
  nodePosition.placeId = val[0]?.placeId || null
}

// map click marker location
const handleSelectMyLocation = (val: any) => {
  // chi tiết location được thêm và marker lúc getAllNodeLocation
  const data = val.data

  if (!data) {
    return
  }

  dataFormAddNode.location = data._id
  dataFormAddNode.locationName = data.locationName
  dataFormAddNode.address = data.address
}

// autocomlete gg map để nhảy đến vị trí trên bản đồ
const handleChoosePosition = async (data: any) => {
  const geocoder = new google.maps.Geocoder()
  const placeInfo = await geocoder.geocode({ placeId: data.place_id })

  if (placeInfo && Array.isArray(placeInfo.results) && placeInfo.results.length > 0) {
    nodePosition.lat = placeInfo.results[0].geometry.location.lat()
    nodePosition.lng = placeInfo.results[0].geometry.location.lng()
    nodePosition.placeId = data.place_id
  }
}

const getAllNodeLocation = async () => {
  const api = $urlSystem.node.location.getAll
  const data: any = await $api(api)
  const resData = data.data.value

  if (resData?.success) {
    const list = resData.data
    locationList.value = list.map((item: any) => ({
      position: {
        lat: parseFloat(item.lat),
        lng: parseFloat(item.lng)
      },
      isNewLocation: item.newLocation,
      icon: item.newLocation ? '/assets/new-location.png' : '/assets/location.png',
      title: item.locationName,
      placeId: item.placeId,
      data: item
    }))
  }
}

watch(
  () => dataFormAddNode.nodeType,
  async (val) => {
    // lấy thông tin nghiệp vụ
    const api = $urlSystem.business.getByNodeType
    if (!val) {
      return
    }

    const data: any = await $api(api, { uriParams: { ID: val } })
    const resData = data?.data?.value
    if (resData?.success) {
      // data update UI

      businessData.value = resData.data
      // data save
      const businesses: { [key: string]: string[] } = resData.data.reduce((acc: any, business: any) => {
        const taskIds = business.tasks.map((task: any) => task._id)
        acc[business._id] = taskIds
        return acc
      }, {})
      dataFormAddNode.businesses = businesses
    }
  }
)

const businessClick = (e: any, id: string, business: any) => {
  e.stopPropagation()
  if (!Object.keys(dataFormAddNode.businesses).includes(id)) {
    dataFormAddNode.businesses[id] = business.tasks.map((task: any) => task._id)
  } else {
    const newObj = Object.keys(dataFormAddNode.businesses).reduce((acc: any, key: any) => {
      if (key !== id) {
        acc[key] = dataFormAddNode.businesses[key]
      }
      return acc
    }, {})

    dataFormAddNode.businesses = newObj
  }
}

const taskClick = (businessId: string, taskId: string) => {
  if (Object.keys(dataFormAddNode.businesses).includes(businessId)) {
    if (!dataFormAddNode.businesses[businessId].includes(taskId)) {
      dataFormAddNode.businesses[businessId].push(taskId)
    } else {
      dataFormAddNode.businesses[businessId] = dataFormAddNode.businesses[businessId].filter((item: any) => item !== taskId)
    }
  } else {
    dataFormAddNode.businesses[businessId] = [taskId]
  }
}

const openTollStationTariff = () => {
  if (addTollStations.value) {
    addTollStations.value.open(dataFormAddNode.tollStationsPrices)
  }
}

const getTollStationStructure = () => {
  const data: { vehicle: { [key: string]: any }; cont: { [key: number]: any } } = { vehicle: {}, cont: {} } as any

  const tollStationStructure = store.data.tollStationStructure

  if (!tollStationStructure) {
    return
  }

  if (tollStationStructure?.vehicle && Array.isArray(tollStationStructure?.vehicle)) {
    tollStationStructure.vehicle.forEach((item: any) => {
      data.vehicle[item.id] = {
        trip: null,
        month: null,
        quarter: null
      }
    })
  }

  if (tollStationStructure?.cont && Array.isArray(tollStationStructure?.cont)) {
    tollStationStructure.cont.forEach((item: number) => {
      data.cont[item] = {
        trip: null,
        month: null,
        quarter: null
      }
    })
  }

  dataFormAddNode.tollStationsPrices = data
}

watch(
  () => dataFormAddNode.nodeTypeName,
  (val) => {
    if (val === 'Trạm thu phí') {
      getTollStationStructure()
    } else {
      dataFormAddNode.tollStationsPrices = {
        vehicle: {},
        cont: {}
      }
    }

    if (val !== 'Kho') {
      dataFormAddNode.warehouseType = ''
    }
  }
)

watch(
  () => dataFormAddNode.holidayWorking,
  (val) => {
    if (!val) {
      dataFormAddNode.holidayWorkingOverTime = false
    }
  }
)

const checkEnterTollStationsPrices = computed(() => {
  return traverseObject(dataFormAddNode.tollStationsPrices)
})

const traverseObject = (obj: any) => {
  let foundNumber = false

  const traverse = (obj: any) => {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const value = obj[key]

        if (Array.isArray(value)) {
          value.forEach(function (item) {
            if (typeof item === 'object' && item !== null) {
              traverse(item)
            } else if (typeof item === 'number') {
              foundNumber = true
            }
          })
        } else if (typeof value === 'object' && value !== null) {
          traverse(value)
        } else if (typeof value === 'number') {
          foundNumber = true
        }
      }
    }
  }

  traverse(obj)

  return foundNumber
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }
  return 'grid-cols-5'
})

const dataSelectWorkFlowData = [
  {
    value: 20,
    label: $t('labels.vehicleModule.20ft')
  },
  {
    value: 40,
    label: $t('labels.vehicleModule.40ft')
  },
  {
    value: 45,
    label: $t('labels.vehicleModule.45ft')
  }
]

const listRadioTypeCommodity = [
  { value: 'NORMAL', label: $t('labels.ordinaryGoods') },
  { value: 'OVERWEIGHT', label: $t('labels.overweightCargo') }
]
const listRadioGoodTypes = [
  { value: 'SOLID', label: $t('labels.solid') },
  { value: 'LIQUID', label: $t('labels.liquid') },
  { value: 'GAS', label: $t('labels.gas') }
]
const listRadioReeferTypes = [
  { value: 'NOTREEFER', label: $t('labels.no') },
  { value: 'REEFER', label: $t('labels.true') }
]
const listRadioDangerousTypes = [
  { value: 'NOTDANGEROUS', label: $t('labels.notDangerous') },
  { value: 'DANGEROUS', label: $t('labels.dangerous') }
]
const listRadioFragileTypes = [
  { value: 'NOTFRAGILE', label: $t('labels.notFragile') },
  { value: 'FRAGILE', label: $t('labels.fragile') }
]

const listWarehouseType = [
  { value: 'BONDED', label: $t('labels.nodeModule.bonded') },
  { value: 'NORMAL', label: $t('labels.nodeModule.normal') }
]
</script>
